import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: Boolean }

  connect() {
    if (!this.openValue) {
      this.contentTarget.style.display = "none"
    }
  }

  toggle() {
    this.openValue = !this.openValue
    
    if (this.openValue) {
      this.contentTarget.style.display = "block"
      // Slide down animation
      this.contentTarget.style.maxHeight = "0"
      this.contentTarget.style.overflow = "hidden"
      this.contentTarget.style.transition = "max-height 0.3s ease-in-out"
      setTimeout(() => {
        this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      }, 10)
      setTimeout(() => {
        this.contentTarget.style.maxHeight = "none"
        this.contentTarget.style.overflow = "visible"
      }, 310)
      
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(180deg)"
      }
    } else {
      // Slide up animation
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.contentTarget.style.overflow = "hidden"
      this.contentTarget.style.transition = "max-height 0.3s ease-in-out"
      setTimeout(() => {
        this.contentTarget.style.maxHeight = "0"
      }, 10)
      setTimeout(() => {
        this.contentTarget.style.display = "none"
      }, 310)
      
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    }
  }
}